// extracted by mini-css-extract-plugin
module.exports = {"tableDetail":"InvoiceForm_tableDetail__TB3fc","stickyFooter":"InvoiceForm_stickyFooter__3hdrM","dragMenu":"InvoiceForm_dragMenu__3eSvj","draggable":"InvoiceForm_draggable__30fma"};